module.exports = __webpack_public_path__ + "static/media/harvast-logo.71d5bf91.svg";